<div
  class="m-2 p-2"
  style="overflow-y: scroll; max-height: 400px; border-radius: 10px"
>
  <!-- starting of  fixed-grid Start -->
  <div
    class="table-container"
    *ngIf="gridQuestion.subQuestions?.length"
    style="overflow-x: auto"
  >
    <table class="table"
      style="
        width: 100%;
        border-collapse: collapse;
        text-align: left;
        border: 1px solid #ddd;
        font-family: Arial, sans-serif;
        /* min-width: max-content; */
      "
    >
      <thead style="background-color: #f4f4f4">
        <tr>
          <th>
            <ng-container>
              <span></span>
            </ng-container>
          </th>
            <th
            *ngFor="let option of gridQuestion.options; let i = index"
            style="padding: 8px; border: 1px solid #ddd; font-weight: bold; text-align: center"
            >
            <ng-container>
              <label 
              style="font-weight: bold; text-align: center; display: block"
              >
              {{ gridQuestion.options[i].value }}
              </label>
            </ng-container>
            </th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of gridQuestion.subQuestions; let rowIndex = index"
          style="background-color: #fff"
        >
          <td style="padding: 8px; border: 1px solid #ddd; font-weight: bold">
            <ng-container>
              <div style="font-weight: bold; display: block; margin: 0" class="table-title-cell">
                {{ gridQuestion.subQuestions[rowIndex].questionText }}
              </div>
            </ng-container>
          </td>
          <td
            *ngFor="let cell of row.subQuestions; let colIndex = index"
            style="padding: 8px; border: 1px solid #ddd; position: relative"
          >
            <ng-container>
              <ng-container>
                <!-- mutlipe choice question started-->
                <div
                  class="gridResponse fixedWidth centerFlex"
                  *ngIf="cell.inputType === 'mul'"
                >
                  <app-inputType-mul
                    [IsReadOnly]="IsReadOnly"
                    [questionIndex]="rowIndex + '-' + colIndex"
                    [showName]="false"
                    [question]="cell"
                    (childQuestion)="GetChildData($event)"
                    (conditionalChange)="isConditionalCheck($event)"
                    (inputChange)="InputChange($event)"
                    
                  ></app-inputType-mul>
                </div>
                <!-- mutlipe choice question ended-->

                <!--combo box started-->
                <div
                  class="fixedWidth centerFlex pr-3"
                  *ngIf="cell.inputType === 'cmb'"
                >
                  <app-inputType-dropdown
                    [IsReadOnly]="IsReadOnly"
                    [questionIndex]="rowIndex + '-' + colIndex"
                    [showName]="false"
                    [question]="cell"
                    (childQuestion)="GetChildData($event)"
                    (conditionalChange)="isConditionalCheck($event)"
                    (inputChange)="InputChange($event)"
                    
                  ></app-inputType-dropdown>
                </div>
                <!--combo box ended-->

                <!-- radio button section started -->
                <div class="fixedWidth centerFlex pr-5" *ngIf="cell.inputType === 'rdo'">
                <ng-container
                  *ngTemplateOutlet="radioButtonTemplate; context: { question: cell, option: gridQuestion.options[colIndex].value,colIndex: colIndex, rowIndex: rowIndex, isReadOnly: IsReadOnly }"
                ></ng-container>
                </div>
                <!-- radio button section ended -->

                <!-- checkbox section started -->
                <div class="fixedWidth centerFlex pr-5" *ngIf="cell.inputType === 'chk'">
              
                  <ng-container
                    *ngTemplateOutlet="checkboxTemplate; context: { question: cell, option: gridQuestion.options[colIndex].value, isReadOnly: IsReadOnly }"
                  ></ng-container>
                </div>
                <!-- checkbox section ended -->

                <!-- text box section started -->
                <div
                  class="fixedWidth centerFlex pr-5"
                  *ngIf="cell.inputType === 'txb' || cell.inputType === 'txa'"
                >
                  <app-inputType-text
                    [IsReadOnly]="IsReadOnly"
                    [questionIndex]="rowIndex + '-' + colIndex"
                    [showName]="false"
                    [question]="cell"
                    [textRows]="1"
                    (childQuestion)="GetChildData($event)"
                    (inputChange)="InputChange($event)"
                    
                  ></app-inputType-text>
                </div>
                <!-- text box section ended -->

                <!-- date picker section started -->
                <div  class="fixedWidth centerFlex pr-5" *ngIf="cell.inputType === 'dte'">
                  <app-inputType-date
                    [IsReadOnly]="IsReadOnly"
                    [questionIndex]="rowIndex + '-' + colIndex"
                    [showName]="false"
                    [question]="cell"
                    (childQuestion)="GetChildData($event)"
                    (inputChange)="InputChange($event)"
                    
                  ></app-inputType-date>
                </div>
                <!-- date picker section ended -->

                <!-- rating section started -->
                <div  class="fixedWidth centerFlex pr-5" *ngIf="cell.inputType === 'rating'">
                  <app-inputType-rating
                    [IsReadOnly]="IsReadOnly"
                    [questionIndex]="rowIndex + '-' + colIndex"
                    [showName]="false"
                    [question]="cell"
                    (childQuestion)="GetChildData($event)"
                    (inputChange)="InputChange($event)"
                    
                  ></app-inputType-rating>
                </div>
                <!-- rating section ended -->

                <!-- signature section started -->
                <div  class="fixedWidth centerFlex pr-5" *ngIf="cell.inputType === 'sign'">
                  <app-inputType-sign
                    [IsReadOnly]="IsReadOnly"
                    [question]="cell"
                    [showName]="false"
                    [questionIndex]="rowIndex + '-' + colIndex"
                    (childQuestion)="GetChildData($event)"
                    (inputChange)="InputChange($event)"
                    
                  ></app-inputType-sign>
                </div>
                <!-- signature section ended -->

                <!-- file upload section started -->
                <div  class="fixedWidth centerFlex pr-5" *ngIf="cell.inputType === 'fileupload'">
                  <app-inputType-fileUpload
                    [questionIndex]="rowIndex + '-' + colIndex"
                    [IsReadOnly]="IsReadOnly"
                    [showName]="false"
                    [question]="cell"
                    (childQuestion)="GetChildData($event)"
                    (inputChange)="InputChange($event)"
                    
                  ></app-inputType-fileUpload>
                </div>
                <!-- file upload section ended -->
              </ng-container>

              <ng-template #textAreaOrLabel>
                <ng-container
                  *ngIf="
                    cell.inputType === 'txb' || cell.inputType === 'txa';
                    else labelOnly
                  "
                >
                  <textarea style="width: 100%"></textarea>
                </ng-container>
                <ng-template #labelOnly>
                    <label style="word-wrap: break-word; max-width: 100ch;">{{ cell.value }}</label>
                </ng-template>
              </ng-template>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- starting of  fixed-grid End -->
</div>


<!---Checkbox template started-->
<ng-template #checkboxTemplate let-question="question" let-option="option" let-isReadonly="isReadOnly">
  <div class="row p-2" style="display: flex;justify-content: space-between;">
    <div class="mat-body-1">   
      <div *ngIf="gridQuestion.options.length > 0">
        <mat-checkbox 
          [checked]="question.responseText === option" 
          [disabled]="isReadonly"
          [ngClass]="{'readOnly':isReadonly}"
          (change)="question.responseText = $event.checked ? option : '';InputChange(true)">
        </mat-checkbox>
      </div>
      <div class="errormsg mat-body-1 margin-top" *ngIf="question.errorMessage && !question.responseText">{{question.errorMessage}}</div>
    </div>
  </div>
</ng-template>
<!--Checkbox templated ended-->


<!---- radio button template started-->
<ng-template #radioButtonTemplate let-question="question" let-option="option" let-rowIndex="rowIndex" let-colIndex="colIndex" let-isReadonly="isReadOnly">
  <div class="row p-2" style="display: flex;justify-content: space-between;">
    <div class="mat-body-1">   
      <div *ngIf="gridQuestion.options.length > 0">
        <mat-radio-group [(ngModel)]="question.responseText">
          <mat-radio-button 
            name="question.responseText"
            [checked]="question.responseText == option" 
            [disabled]="isReadonly"
            [ngClass]="{'readOnly':isReadonly}"
            [value]="option"
            (change)="InputChange(true)"
            >
          </mat-radio-button>
        </mat-radio-group>
      </div>  
      <div class="errormsg mat-body-1 margin-top" *ngIf="question.errorMessage && !question.responseText">{{question.errorMessage}}</div>
    </div>
  </div>
</ng-template>
<!---- radio button template ended-->